import axios from 'axios';
import { getBackOfficeRoute, headers } from './header';

const FeedbacksApiService = {
  getFeedbacks(token, role, format) {
    if (format === undefined || format === null) {
      format = 'json';
    }
    return axios
      .get(`${getBackOfficeRoute(role)}/rent-feedbacks?format=${format}`,
        {
          headers: headers(token),
        },
      )
      .then((response) => response.data);
  }
}

export default FeedbacksApiService;



// WEBPACK FOOTER //
// ./src/services/api/FeedbacksApiService.js